/* eslint-disable import/no-extraneous-dependencies */
// i18n
import 'src/locales/i18n';

// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// locales
import { LocalizationProvider } from 'src/locales';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
// auth
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';

import { Provider } from 'react-redux';
import { store } from './utils/store.tsx';

import { SettingsProvider, SettingsDrawer } from './components/settings';
import PwaInstallPrompt from './components/pwa-install-prompt/pwa-install-prompt.tsx';

// ----------------------------------------------------------------------

export default function App() {
  const charAt = `
  ░░░░░  ░░░  ░   ░ ░░░░   ░░░░ ░░░░░    ░░░░  ░░░  ░░░░  ░░░ ░   ░  ░░░░
  ▒     ▒   ▒ ▒   ▒ ▒   ▒ ▒     ▒       ▒     ▒   ▒ ▒   ▒  ▒  ▒▒  ▒ ▒
  ▒▒▒▒  ▒   ▒ ▒   ▒ ▒▒▒▒  ▒     ▒▒▒▒    ▒     ▒   ▒ ▒   ▒  ▒  ▒ ▒ ▒ ▒  ▒▒
      ▓ ▓   ▓ ▓   ▓ ▓  ▓  ▓     ▓       ▓     ▓   ▓ ▓   ▓  ▓  ▓  ▓▓ ▓   ▓
  █████  ███   ███  █   █  ████ █████    ████  ███  ████  ███ █   █  ████
  `;

  console.info(`%c${charAt}`, 'color: #5BE49B');

  useScrollToTop();

  return (
    <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: true,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <PwaInstallPrompt />
                <SettingsDrawer />
                <ProgressBar />
                <AuthConsumer>
                  <Provider store={store}>
                    <Router />
                  </Provider>
                </AuthConsumer>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
